import React, { Component } from 'react';
import {
    Modal,
    Button,
    Input,
    Icon,
    Tooltip,
} from 'antd';
import 'antd/dist/antd.css';
import './UploadFolderModal.less';
class UploadFolderModal extends Component {

    state = {
        visible: false,
    };

    show = () => {
        this.setState({
            visible: true,
        });
    }

    hide = () => {
        this.changeVisible(false);
        this.props.resetAllSettings()
    }

    changeVisible = value => {
        this.setState({
            visible: value,
        });
    }

    render() {
        const {
            visible,
        } = this.state;
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        const {
            loading,
            pathName,
            folderName,
            uploadStatus,
            totalSize,
            totalFiles,
            currentFileIndex,
            selectedFiles,
            isProcessing,
            version,
        } = this.props;
        const pathNameArr = pathName.split('-->');
        let pathNameshow = pathNameArr.slice(0, 3).join('-->');
        if(pathNameArr.length > 3) {
            pathNameshow += '...';
        }

        // 当前上传文件名
        let currentFileName = '未知文件';
        if (currentFileIndex >= 0 && selectedFiles && selectedFiles[currentFileIndex] && selectedFiles[currentFileIndex].name) {
            currentFileName = selectedFiles[currentFileIndex].name;
        }

        // 当前阶段文本（上传中/处理中）
        let stageText = '正在上传';
        if (isProcessing) {
            stageText = '正在处理（后台响应中）';
        }

        return (
            <Modal
                title={'上传文件夹'}
                visible={visible}
                onCancel={this.hide}
                onOk={this.props.startBatchUpload}
                className="preview-modal"
                maskClosable={false}
                confirmLoading={loading}
                width="500px"
            >
                <div className="modal-content" style={{ padding: '20px 30px' }}>
                    <ul className="modal-list">
                        <li className="modal-item">
                            <div style={{ marginLeft: 40 }}>
                                <Tooltip title={pathName}>
                                    {pathNameshow}
                                </Tooltip>
                            </div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left" style={{ width: '40%' }}>{asterisk}上传文件夹：</div>
                            <div className="item-right" style={{ width: '60%' }}>
                                {/* 选择文件夹按钮 */}
                                <Button
                                    type="default"
                                    onClick={this.props.openFolderSelector}
                                    disabled={uploadStatus === 'uploading'}
                                >
                                    选择文件夹
                                </Button>

                                {/* 已选中文件夹信息 */}
                                {folderName && (
                                    <div className='selected-folder-info' style={{ marginTop: 10, color: '#666' }}>
                                        <span className='selected-folder-info-text'>
                                            已选中：{folderName}（共{totalFiles}个文件，总大小{this.props.formatSize(totalSize)}）
                                        </span>
                                        <span className='selected-folder-info-del' onClick={this.props.resetFolderSelector}><Icon type="close" /></span>
                                        
                                    </div>
                                )}

                            </div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left" style={{ width: '40%' }}>{asterisk}版本号：</div>
                            <div className="item-right" style={{ width: '60%' }}>
                                <Input
                                    placeholder='请输入'
                                    style={{ width: 160 }}
                                    value={version}
                                    onChange={e => this.props.handleVersionChange(e.target.value)}
                                />
                            </div>
                        </li>

                    </ul>
                </div>
            </Modal>
        );
    }
}

export default UploadFolderModal;


// WEBPACK FOOTER //
// ./src/components/documentManagement/departmentalDocuments/UploadFolderModal.js